import React from 'react';
import './login.css'
import Sec1login from '../sections/sec1_login';


const Loginpage = () => {
    return ( 
        <>
            <Sec1login />
        </>
     );
}
 
export default Loginpage;